<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">扫码添加</div>
                </van-col>
                <van-col span="6">
                    <div class="album">
                        <qrcode-capture @decode="onDecode" :capture="selected.value"/>
                        相册
                    </div>

                </van-col>
            </van-row>
        </div>
        <div class="qr-show">
            <qrcode-stream
                    v-show="qrcode"
                    :camera="camera"
                    :torch="torchActive"
                    @decode="onDecode"
                    @init="onInit"
            >
                <div>
                    <div class="qr-scanner">
                        <div class="box">
                            <div class="line"></div>
                            <div class="angle"></div>
                        </div>
                        <div class="txt">
                            请将二维码放入框内，即可自动扫描
                        </div>
                        <img class="light" @click="torchActive = !torchActive" src="@/assets/share/qrAdd/light.png">
                        <div class="cancel-qr" @click="toQr">我的二维码</div>
                    </div>
                </div>
            </qrcode-stream>
            <!--            <div class="input-qr">-->
            <!--                <qrcode-capture @decode="onDecode" :capture="selected.value" />-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
    import {QrcodeStream, QrcodeCapture} from 'vue-qrcode-reader';

    export default {
        name: 'qrAdd',
        components: {QrcodeStream, QrcodeCapture},
        data() {
            const options = [
                {text: "rear camera (default)", value: "environment"},
                {text: "front camera", value: "user"},
                {text: "force file dialog", value: false},
            ]
            return {
                result: '', // 扫码结果信息
                error: '', // 错误信息
                // show: false,
                // qrcode: false,
                qrcode: true,
                torchActive: false,
                camera: 'rear',
                options,
                selected: options[2],
                capture: false,
            }
        },
        methods: {
            back() {
                this.$router.back();
            },
            toQr() {
                this.$router.push({
                    name: 'myQr'
                })
            },
            onDecode(result) {
                this.result = result;
                console.log(result)
                this.findMembers();
            },
            async onInit(promise) {
                const {capabilities} = await promise;

                const TORCH_IS_SUPPORTED = !!capabilities.torch;
                try {
                    await promise;
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = 'ERROR: 您需要授予相机访问权限';
                    } else if (error.name === 'NotFoundError') {
                        this.error = 'ERROR: 这个设备上没有摄像头';
                    } else if (error.name === 'NotSupportedError') {
                        this.error = 'ERROR: 所需的安全上下文(HTTPS、本地主机)';
                    } else if (error.name === 'NotReadableError') {
                        this.error = 'ERROR: 相机被占用';
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = 'ERROR: 安装摄像头不合适';
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = 'ERROR: 此浏览器不支持流API';
                    }
                }
            },
            findMembers() {
                this.$api.share.findMembers({
                    sharerId: this.result
                }).then(res => {
                    let user = res.info;
                    localStorage.setItem("addUser", JSON.stringify(user));
                    this.$router.push({
                        name: 'confirm',
                        params: {
                            type: 'qr'
                        }
                    })
                }).catch(e => {
                    this.$router.push({
                        name: 'qrResult',
                        params: {
                            result: this.result
                        }
                    })
                })
            },
            toTest() {
                this.$router.push({
                    name: 'test'
                })
            }
        }
    }
</script>

<style scoped>

    .album {
        font-size: 14px;
        color: #20D38F;
        margin-top: 15px;
        margin-right: 15px;
        text-align: right;
    }

    .qr-scanner {
        width: 100%;
        height: calc(100vh - 46px);
        position: relative;
    }

    .qr-scanner .box {
        width: 234px;
        height: 234px;
        position: absolute;
        left: 50%;
        top: 50px;
        transform: translate(-50%, 0);
        overflow: hidden;
        border: 1px solid #11573C;
        /*background: #111D18;*/
    }

    .qr-scanner .txt {
        width: 100%;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        margin: 0 auto;
        position: absolute;
        top: 314px;
        left: 0;
    }

    .light {
        position: absolute;
        top: 388px;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
    }

    .qr-scanner .myQrcode {
        text-align: center;
        color: #00ae10;
    }

    .qr-scanner .line {
        height: calc(100% - 2px);
        width: 100%;
        background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #20D38F 211%);
        border-bottom: 3px solid #20D38F;
        transform: translateY(-100%);
        animation: radar-beam 2s infinite alternate;
        animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
        animation-delay: 1.4s;
    }

    .qr-scanner .box:after,
    .qr-scanner .box:before,
    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
        content: '';
        display: block;
        position: absolute;
        width: 26px;
        height: 26px;

        border: 4px solid transparent;
    }

    .qr-scanner .box:after,
    .qr-scanner .box:before {
        top: 0;
        border-top-color: #20D38F;
    }

    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
        bottom: 0;
        border-bottom-color: #20D38F;
    }

    .qr-scanner .box:before,
    .qr-scanner .angle:before {
        left: 0;
        border-left-color: #20D38F;
    }

    .qr-scanner .box:after,
    .qr-scanner .angle:after {
        right: 0;
        border-right-color: #20D38F;
    }

    @keyframes radar-beam {
        0% {
            transform: translateY(-100%);
        }

        100% {
            transform: translateY(0);
        }
    }

    .cancel-qr {
        position: absolute;
        bottom: 34px;
        color: #ffffff;
        font-size: 15px;
        background: #202020;
        border-radius: 14px;
        width: 359px;
        left: 8px;
        text-align: center;
        line-height: 56px;
    }

    input {
        position: absolute;
        width: 25%;
        height: 100%;
        top: 0;
        right: 0;
        outline: none;
        filter: alpha(opacity=0);
        -moz-opacity: 0;
        -khtml-opacity: 0;
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/qrAdd.vue